import MinRequest from './MinRequest'
import axios from "axios";

import {MessageBox} from 'element-ui';
const minRequest = new MinRequest()
// 请求拦截器
minRequest.interceptors.request((request) => {
  return request
})
// 响应拦截器
minRequest.interceptors.response((response) => {
    //当返回信息为未登录或者登录失效的时候重定向为登录页面
    if (response.code == 401) {
      MessageBox.confirm("权限不足，请联系管理员！", '温馨提示', {
        confirmButtonText: '确定',
        type: "warning"
      }).then(function () {
        console.error("权限不足，请联系管理员！");
      })
    }
    if (response.code == 302) {
      MessageBox.confirm(response.info, '温馨提示', {
        confirmButtonText: '确定',
        type: "warning"
      }).then(function () {
        window.location.reload();
      })
    }
    return response;
  },
  error => {
    checkSession();
    return Promise.reject(error)
  })

function checkSession() {
  axios.get("/api/sys/checkSession").then(function (response) {
  }).catch(function (error) {
    console.log(error)
  });
}

// 设置默认配置:小程序端需要设置基础路径
const baseURL = "";
console.log(baseURL)
minRequest.setConfig((config) => {
  config.baseURL = baseURL;
  return config
})
export default {
  //get请求
  doGet(url, data) {
    return minRequest.get(url, data)
  },
  //post请求
  doPost(url, data) {
    return minRequest.post(url, data)
  },
  getToken(data) {
    return minRequest.get('/api/login/getToken', data)
  },
  //获取用户菜单
  getMenuUserTree(data) {
    return minRequest.post('/api/sys/getMenuUserTree', data)
  },
  //获取用户路由
  getUserRoutes(data) {
    return minRequest.post('/api/sys/getUserRoutes', data)
  },
  //获取数据字典
  getDictList(data) {
    return minRequest.post('/api/sys/getDictList', data)
  },
  //获取配置信息
  getConfig(data) {
    return minRequest.post('/api/sys/getAdminConfig', data)
  },
  //退出登录
  getLoginOut(data) {
    return minRequest.post('/admin/login/loginOut', data)
  },
  //获取用户数据
  getUserInfo(data) {
    return minRequest.post('/admin/login/getUserInfo', data)
  },
  //修改用户数据
  updateUserInfo(data) {
    return minRequest.post('/admin/sysUser/updateUserInfo', data)
  },
  //获取登录信息
  getLoginInfo(data) {
    return minRequest.post('/admin/login/getLoginInfo', data)
  },
  //获取文件历史
  getFileHistory(data) {
    return minRequest.get('/admin/sysAttach/getFileHistory?refId=' + data.refId)
  },
  //删除文件
  deleteFile(data) {
    return minRequest.get('/admin/sysAttach/deleteFile?id=' + data.id)
  },
  //*************************************客户端接口************************************
  //获取授权信息:位置
  getFrontUserAuthor(data) {
    return minRequest.post('/api/login/userAuthor', data)
  },
  //获取登录信息
  getFrontLoginInfo(data) {
    return minRequest.post('/api/login/getLoginInfo', data)
  },
  //修改用户数据
  updateFrontUserInfo(data) {
    return minRequest.post('/api/login/updateUserInfo', data)
  },

}



// WEBPACK FOOTER //
// ./src/js/request/apis.js